import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Button, Modal } from "react-bootstrap";
import { useLang } from "../contexts/LanguageContext";
import translations, { languageMeta } from "../translations";
import FormFeedback from "./FormFeedback";

const SettingsOffCanvas = ({ show, onClose, onLogout }) => {
  const { lang, setLang, t } = useLang();
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);

  const handleLanguageChange = (event) => {
    setLang(event.target.value);
  };

  const languageOptions = Object.keys(translations).map((code) => ({
    code,
    label: languageMeta[code]?.label || code.toUpperCase(),
  }));

  useEffect(() => {
    if (!show) {
      setShowFeedbackModal(false);
    }
  }, [show]);

  const handleOpenFeedback = () => setShowFeedbackModal(true);
  const handleCloseFeedback = () => setShowFeedbackModal(false);

  return (
    <Offcanvas show={show} onHide={onClose} placement="end">
      <Offcanvas.Header closeButton  closeVariant="white">
        <Offcanvas.Title>{t("SETTINGS_PANEL_TITLE") || "Settings"}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body
        className="d-flex flex-column gap-4"
        style={showFeedbackModal ? { overflow: "hidden" } : undefined}
      >
        <Button variant="outline-primary" onClick={handleOpenFeedback}>
          {t("SETTINGS_FEEDBACK_CTA") || "Help us improve"}
        </Button>
        <Form.Group controlId="readerumLanguageSelector">
          <Form.Label>{t("SETTINGS_LANGUAGE_LABEL") || "Interface language"}</Form.Label>
          <Form.Select value={lang} onChange={handleLanguageChange}>
            {languageOptions.map(({ code, label }) => (
              <option key={code} value={code}>
                {label}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <div className="mt-auto">
          <Button variant="outline-danger" className="w-100" onClick={onLogout}>
            {t("HOME_LOGOUT_BUTTON")}
          </Button>
        </div>
      </Offcanvas.Body>
      <Modal
        show={showFeedbackModal}
        onHide={handleCloseFeedback}
        dialogClassName="settings-feedback-modal"
      >
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>{t("SETTINGS_FEEDBACK_TITLE") || "We want to hear from you"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormFeedback key={showFeedbackModal ? "open" : "closed"} formName="SettingsFeedback" />
        </Modal.Body>
      </Modal>
    </Offcanvas>
  );
};

export default SettingsOffCanvas;
